module.exports = __webpack_public_path__ + "static/media/22_2021_Clinical_Guidelines_7.29.2021_fp.600e8090.pdf";